import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import PurchaseReciept from  './PurchaseReciept'


function ViewpurchaseReciept() {
    return (
        <div className='d-flex flex-column' style={{ height: '100vh' }}>
            <Helmet>
                <title>GRN - View</title>
            </Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
                <PurchaseReciept />
            </div>
        </div>
    )
}

export default ViewpurchaseReciept
